<template>
    <div class="page-notification-show">
        <div class="boxes page-node-show">
            <div class="box">
                <div class="box-heading border-bottom" style="position: relative;">
                    <h5>
                        <lock-clock-icon class="mr-1" style="font-size: 20px;"></lock-clock-icon>
                        定时动态任务
                    </h5>
                </div>
                <div class="threads-items mb-2">
                    <ul class="list-group list-group-flush">
                        <li
                            class="list-group-item d-md-flex d-block align-items-center justify-content-between cursor-pointer"
                        >
                            <div class="d-flex align-items-center w-15">
                                <div class="text-gray">
                                    预计发布
                                </div>
                            </div>
                            <div class="d-flex align-items-center w-45">
                                <div class="text-gray">
                                    动态信息
                                </div>
                            </div>
                            <div class="d-flex align-items-center w-15">
                                <div class="text-gray">
                                    IP
                                </div>
                            </div>
                            <div class="d-flex align-items-center w-15">
                                <div class="text-gray">
                                    创建时间
                                </div>
                            </div>
                            <div class="d-flex align-items-center w-10">
                                <div class="text-gray">
                                    操作
                                </div>
                            </div>
                        </li>

                        <li
                            class="list-group-item d-md-flex d-block align-items-center justify-content-between cursor-pointer"
                            v-for="item in schedules"
                            :key="item.id"
                        >
                            <div class="d-flex align-items-center w-15">
                                <div class="text-gray">
                                    {{ item.show_push_time }}
                                    <br>
                                    <small>{{ item.push_time }}</small>
                                </div>
                            </div>
                            <div class="d-flex align-items-center w-45">
                                <div class="text-gray">
                                    标题：{{ item.dynamic_title }}
                                    <br>
                                    <div class="content">内容：{{ item.dynamic_markdown }}</div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center w-15">
                                <div class="text-gray">
                                    {{ item.created_ip }}
                                </div>
                            </div>
                            <div class="d-flex align-items-center w-15">
                                <div class="text-gray">
                                    {{ item.show_make_time }}
                                    <br>
                                    <small>{{ item.make_time }}</small>
                                </div>
                            </div>
                            <div class="d-flex align-items-center w-10">
                                <div class="text-gray">
                                    <a @click="handleDelete(item)">删除</a>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="text-center text-gray-50" v-if="schedules.length <= 0">
                        <empty-state message="尚未设置计划发布动态的任务~">
                            <template slot="icon">
                                <inbox-icon></inbox-icon>
                            </template>
                        </empty-state>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import InboxIcon from '$icons/Inbox'
    import CheckIcon from '$icons/Check'
    import LockClockIcon from '$icons/LockClock'
    import EmptyState from '$components/empty-state'

    export default {
        components: {
            EmptyState,
            InboxIcon,
            CheckIcon,
            LockClockIcon,
        },
        data () {
            return {
                schedules: [],
            }
        },
        created () {
            this.loadSchedules();
        },
        methods: {
            loadSchedules () {
                this.$http
                    .get(`/dynamic/schedules`)
                    .then(res => {
                        this.schedules = res.data;
                    })
            },
            handleDelete (item) {
                this.$confirm('确定要删除`' + item.dynamic_title + '`的定时动态任务吗？', '删除`定时动态任务`提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    this.$http.delete(`/dynamic/delete-schedule`, {
                        data: {
                            id: item.id
                        }
                    }).then((res) => {
                        this.$message.success(res.msg);
                        // 重新加载列表
                        this.loadSchedules();
                    })
                });
            },
        }
    }
</script>

<style>
.content{
    display: -webkit-box; /* 此项属性是兼容webkit浏览器 */
    overflow: hidden; /* 隐藏超出三行的内容 */
    -webkit-line-clamp: 10; /* 显示三行 */
    -webkit-box-orient: vertical; /* 垂直显示 */
}
</style>